/**
 * Created by leo on 20/06/06.
 * @author leo.wang 17503046966@163.com;
 */
export default {
  /**
   * 删除字符串左右两边空格
   * @param {String} s 字符串
   */
  trim(s) {
    return this.trimRight(this.trimLeft(s));
  },

  /**
   * 删除字符串左边空格
   * @param {String} s 字符串
   */
  trimLeft(s) {
    if (s == null) {
      return "";
    }
    var whitespace = new String(" \t\n\r");
    var str = new String(s);
    if (whitespace.indexOf(str.charAt(0)) != -1) {
      var j = 0,
        i = str.length;
      while (j < i && whitespace.indexOf(str.charAt(j)) != -1) {
        j++;
      }
      str = str.substring(j, i);
    }
    return str;
  },

  /**
   * 删除字符串右边空格
   * @param {String} s 字符串
   */
  trimRight(s) {
    if (s == null) return "";
    var whitespace = new String(" \t\n\r");
    var str = new String(s);
    if (whitespace.indexOf(str.charAt(str.length - 1)) != -1) {
      var i = str.length - 1;
      while (i >= 0 && whitespace.indexOf(str.charAt(i)) != -1) {
        i--;
      }
      str = str.substring(0, i + 1);
    }
    return str;
  },

  /**
   * 删除字符串最后一个字符
   * @param {String} s 字符串
   */
  deleteLastCharacter(s) {
    return s.Substring(0, s.Length - 1)
  },

  //字符串转base64
  encode(str) {
    // 对字符串进行编码
    var encode = encodeURI(str);
    // 对编码的字符串转化base64
    var base64 = btoa(encode);
    return base64;
  },

  // base64转字符串
  decode(base64) {
    // 对base64转编码
    var decode = atob(base64);
    // 编码转字符串
    var str = decodeURI(decode);
    return str;
  }
}


// WEBPACK FOOTER //
// ./src/leo.wang.util/operator.string.js